export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos del formulario No."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Falta la identificación requerida"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Has iniciado sesión exitosamente, continúa operaciones en el cajero automático"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuar transacciones en cajeros automáticos"])}
}